<template>
  <div>
    <el-dialog title="用户画像" :visible.sync="dialogVisible" width="80%">
      <h1>{{ offlineVipId }}</h1>
      <ul class="info-list">
        <li class="flex">
          <div class="title">
            <span>基本信息</span>
          </div>
          <div class="content">
            <div>
              <span>用户名：{{ customerDetail.realName }}</span>
              <span>商城昵称：{{ customerDetail.memberUserName }}</span>
              <span>手机号：{{ customerDetail.mobilePhone }}</span>
              <span>线上关注时间：{{ customerDetail.bindTime }}</span>
            </div>
            <div>
              <span>会员卡号：{{ customerDetail.memberNum }}</span>
              <span>开卡日期：{{ customerDetail.regDate }}</span>
            </div>
            <div>
              <span>宝妈姓名：{{ customerDetail.motherName }}</span>
              <span>孕期信息：{{ customerDetail.weeksOfPregnancy }}</span>
            </div>
            <div>
              <span>宝爸姓名：{{ customerDetail.fatherName }}</span>
            </div>
            <div v-for="(item, i) in customerDetail.babyList" :key="i">
              <span>宝宝姓名：{{ item.fullName }}</span>
              <span>宝宝性别：{{ item.babyGender }}</span>
              <span>宝宝生日：{{ item.babyBirthDay }}</span>
              <span>宝宝生理轴年龄段：{{ item.babyAgeAsString }}</span>
            </div>
          </div>
        </li>
        <li class="flex">
          <div class="title">
            <span>归属信息</span>
          </div>
          <div class="content">
            <div>
              <span>归属导购：{{ customerDetail.storeGuiderName }}</span>
              <span>关系建立的时间：{{ customerDetail.regTime }}</span>
              <span>关系建立的方式：{{ customerDetail.subscribeType }}</span>
            </div>
            <div class="flex">
              <span>门店偏好：{{ customerDetail.storeOutletName }}</span>
            </div>
          </div>
        </li>
        <li class="flex">
          <div class="title">
            <span>消费信息</span>
          </div>
          <div class="content">
            <div>
              <span
                >最近一次购买时间：{{ customerDetail.lastShoppingTime }}</span
              >
              <span>消费金额：{{ customerDetail.currentYearAmount }}</span>
              <span>积分信息：{{ customerDetail.points }}</span>
            </div>
            <div>
              <span>消费水平：{{ customerDetail.consumeCapacity }}</span>
              <span>总消费次数：{{ customerDetail.orderCount }}</span>
              <span>客户活跃度：{{ customerDetail.memberActiveLevel }}</span>
            </div>
            <div>
              <span
                >消费种类分类:食品、用品：{{ customerDetail.buyBrands }}</span
              >
            </div>
            <div>
              <span>品牌偏好：{{ customerDetail.favoriteBrand }}</span>
            </div>
          </div>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false" size="small"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    offlineVipId: { type: String },
    currentRow: { type: Object }
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  computed: mapState({
    memeberId: state => state.marketing.memeberId,
    customerDetail: state => state.marketing.customerDetail
  }),
  watch: {
    currentRow() {},
    dialogVisible(val) {
      if (!val) {
        this.$store.state.marketing.customerDetail = {
          weeksOfPregnancy: 0,
          babyList: []
        };
      }
    },
    offlineVipId(val) {
      if (val !== "") {
        this.$store
          .dispatch("queryMemberId", {
            cardNo: val
          })
          .then(() => {
            this.$emit("resetOfflineId", true);
          });
        this.dialogVisible = true;
      }
    },
    memeberId(val) {
      if (val) {
        this.$store
          .dispatch("getCustomerDetail", {
            memberOfflineId: val,
            userId: this.currentRow.userId,
            workNum: this.currentRow.workNum,
            position: this.currentRow.position,
            storeOutletId: this.currentRow.storeOutletId
          })
          .then(() => {
            this.$store.state.marketing.memeberId = "";
          });
        this.showCustomerDetail = true;
      }
    }
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.info-list {
  border-top: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
  li {
    padding: 5px 0;
    border-bottom: 1px solid #f7f7f7;
  }
  li:last-child {
    border: none;
  }
  .title {
    display: flex;
    align-items: center;
    border-right: 1px solid #999999;
    margin: 5px 0;
    padding: 0 10px;
    width: 60px;
    font-size: 14px;
  }
  .content {
    flex-wrap: wrap;
    padding: 0 10px;
    flex: 1;
    div {
      display: flex;
      border-bottom: 1px solid #ececec;
      > span {
        padding: 0 10px;
        margin: 10px 0;
        border-right: 1px solid #d2d2d2;
      }
      > span:last-child {
        border: none;
      }
    }
    div:last-child {
      border: none;
    }
  }
}
</style>
